import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=6a393efc&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=6a393efc&prod&scoped=true&lang=css"
import style1 from "./CommentForm.vue?vue&type=style&index=1&id=6a393efc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a393efc",
  null
  
)

export default component.exports